import { io, ManagerOptions, Socket, SocketOptions } from 'socket.io-client';
import { ConnectionStatus } from '../custom.d';
import { SERVER_ENDPOINT } from '../utils/constants';

export class SocketManager {
  private readonly socket: Socket | null = null;
  private status: ConnectionStatus = ConnectionStatus.DISCONNECTED;

  private onStatusChangeCallbacks: Array<(status: ConnectionStatus) => void> = [];

  constructor(
    protected readonly url: string,
    protected readonly options?: Partial<SocketOptions & ManagerOptions>,
  ) {
    this.socket = io(
      this.url,
      {
        ...(this.options || {}),
        autoConnect: false,
      });
    this.setStatus(ConnectionStatus.CONNECTING);

    this.setEventListeners();
    // connect to websockets only on the client side
    typeof window !== "undefined" && this.socket.connect();
  }

  public getStatus() {
    return this.status;
  }

  public getSocket() {
    return this.socket;
  }

  public onStatusChange(cb: (status: ConnectionStatus) => void) {
    this.onStatusChangeCallbacks.push(cb);
  }

  public disconnect() {
    this.socket?.disconnect();
  }

  private setEventListeners() {
    this.socket
      .on('connect', () => {
        this.setStatus(ConnectionStatus.CONNECTED);
        console.log('[SocketManager] Connected: ', this.socket.id);
      })
      .on('disconnect', (reason) => {
        this.setStatus(ConnectionStatus.DISCONNECTED);
        console.warn('[SocketManager] Disconnected. Reason: ', reason);
      })
      .on('connect_error', (error) => {
        this.setStatus(ConnectionStatus.ERROR);
        console.error('[SocketManager] Connection error: ', error);
      })
      .on('error', (error) => {
        this.setStatus(ConnectionStatus.ERROR);
        console.error('[SocketManager] General error: ', error);
      });

    this.socket.io
      .on('reconnect_attempt', (attempt) => {
        this.setStatus(ConnectionStatus.RECONNECTING);
        console.warn(`[SocketManager] Reconnect attempt #${attempt}`);
      })
      .on('reconnect_failed', () => {
        this.setStatus(ConnectionStatus.ERROR);
        console.error('[SocketManager] Reconnect failed');
      })
      .on('error', (error) => {
        this.setStatus(ConnectionStatus.ERROR);
        console.error('[SocketManager] General error: ', error);
      });
  }

  private setStatus(status: ConnectionStatus) {
    this.status = status;

    for (const cb of this.onStatusChangeCallbacks) {
      cb(status);
    }
  }
}

export const socketManager = new SocketManager(SERVER_ENDPOINT, {
      reconnection: true,
      reconnectionDelay: 3000,
      secure: true,
});

